import blog from 'publisher/reducers/blogReducer'
import files from 'publisher/reducers/filesReducer'
import lecture from 'publisher/reducers/lectureReducer'
import management from 'publisher/reducers/managementReducer'
import optIn from 'publisher/reducers/optInReducer'
import page from 'publisher/reducers/pageReducer'
import payment from 'publisher/reducers/paymentReducer'
import webinar from 'publisher/reducers/webinarReducer'
import webinarSession from 'publisher/reducers/webinarSession'
import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from 'redux'
import { thunk } from 'redux-thunk'
import { websiteSettingsReducer } from 'src/publisher/store/website-settings/website-settings-reducer'

const configureStore = preloadedState => {
  // eslint-disable-next-line no-underscore-dangle

  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose
  return createStore(
    combineReducers({
      page,
      files,
      optIn,
      management,
      payment,
      blog,
      webinar,
      webinarSession,
      lecture,
      websiteSettings: websiteSettingsReducer,
    }),
    preloadedState,
    composeEnhancers(applyMiddleware(thunk)),
  )
}

export default configureStore
